import React from "react";
import { Hash, Users, Megaphone, LifeBuoy, ShoppingBag, MessageCircle } from "lucide-react";
import { StarBadge } from "@/components/social/Stars";

const CHANNEL_ICON = { general: Hash, ventas: ShoppingBag, ayuda: LifeBuoy, anuncios: Megaphone };

const Avatar = ({ person, size = 40 }) => {
  const [failed, setFailed] = React.useState(false);
  const src = person?.photo
    ? (person.photo.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${person.photo}` : person.photo)
    : null;
  return src && !failed ? (
    <img src={src} alt="" onError={() => setFailed(true)}
      className="rounded-full object-cover border border-white/15"
      style={{ width: size, height: size }} />
  ) : (
    <div className="rounded-full flex items-center justify-center text-white font-semibold border border-white/15"
      style={{ width: size, height: size, background: "linear-gradient(135deg,#B4560E,#2A1403)", fontSize: size / 2.6 }}>
      {(person?.name || "?").slice(0, 1).toUpperCase()}
    </div>
  );
};

export { Avatar };

export const ChatList = ({ conversations, activeId, onSelect, typing }) => (
  <div className="space-y-1.5" data-testid="chat-list">
    {conversations.map((c) => {
      const other = c.people?.[0];
      const title = c.type === "dm" ? (other?.name || "Chat") : c.title;
      const Icon = c.type === "channel" ? (CHANNEL_ICON[c.channel_key] || Hash)
        : c.type === "group" ? Users : MessageCircle;
      const isTyping = typing?.[c.conv_id];
      return (
        <button key={c.conv_id} data-testid={`chat-item-${c.conv_id}`} onClick={() => onSelect(c)}
          className={`w-full text-left px-3 py-2.5 rounded-xl flex items-center gap-3 transition-colors ${
            activeId === c.conv_id ? "bg-white/10 border border-red-500/40" : "hover:bg-white/5 border border-transparent"
          }`}>
          {c.type === "dm" ? <Avatar person={other} size={38} /> : (
            <div className="w-[38px] h-[38px] rounded-full flex items-center justify-center bg-white/8 border border-white/12">
              <Icon className="w-4 h-4 text-red-400" />
            </div>
          )}
          <div className="min-w-0 flex-1">
            <div className="flex items-center justify-between gap-2">
              <span className="text-sm text-white truncate">{title}</span>
              {c.type === "dm" && <StarBadge level={other?.level} className="shrink-0" />}
              {c.unread > 0 && (
                <span data-testid={`unread-${c.conv_id}`}
                  className="shrink-0 text-[10px] font-bold px-1.5 py-0.5 rounded-full bg-red-600 text-white">
                  {c.unread}
                </span>
              )}
            </div>
            <div className="text-[11px] text-white/45 truncate">
              {isTyping ? <span className="text-red-400">escribiendo…</span>
                : c.last_message?.text || c.description || "Sin mensajes"}
            </div>
          </div>
        </button>
      );
    })}
  </div>
);

export default ChatList;
